import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OrganizationStoreService } from '../../../shared/services/organization-store.service';

export const surveySelectedGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const organizationStore = inject(OrganizationStoreService);

  const organizationId = organizationStore.selectedOrganizationId();
  if (!organizationId) {
    return router.parseUrl('/organizations');
  }

  const surveyId = route.paramMap.get('id');
  const surveys = organizationStore.getSelectedOrganizationSurveys();
  if (!surveyId || !surveys.some(s => s.id === surveyId)) {
    return router.parseUrl('/surveys');
  }

  if (organizationStore.selectedSurveyId() !== surveyId) {
    organizationStore.setSurveyById(surveyId);
  }

  return true;
};
